import axios from 'axios'

import i18n from '@plugins/i18n'
import sdk from '@service/auth-sdk'
import {
  applyTaskToUploadItem,
  extractTaskId,
  registerTaskSource,
  unregisterTaskSource,
} from '@utils/upload-task-poll'

const POLL_SOURCE_KEY = 'upload'

function bindTaskPoller(state, commit) {
  registerTaskSource(POLL_SOURCE_KEY, {
    getItems: () => Object.values(state.queue || {}),
    onUpdate: (updates) => {
      updates.forEach(({ item, task }) => {
        commit('updateQueue', {
          id: item.id,
          queue: applyTaskToUploadItem(item, task),
        })
      })
    },
  })
}

export default {
  namespaced: true,
  state: {
    isShowDialog: false,
    progressFiles: [],
    queue: {},
    configSend: {},
  },
  getters: {
    isShowDialog: (state) => state.isShowDialog,
    progressFiles: (state) => state.progressFiles,
    getProgressFileById: (state) => (id) => state.queue[id],
  },
  mutations: {
    showDialog(state) {
      state.isShowDialog = true
    },
    closeDialog(state) {
      unregisterTaskSource(POLL_SOURCE_KEY)
      state.isShowDialog = false
      state.progressFiles = []
      state.queue = {}
      state.configSend = {}
    },
    setQueueUpload(state, file) {
      state.progressFiles.push(file)
      state.queue[file.id] = file
    },
    updateQueue(state, { id, queue }) {
      state.progressFiles = state.progressFiles.filter((x) => x.id != id)
      state.queue[id] = queue
      state.progressFiles.push(queue)
    },
    removeQueueUpload(state, id) {
      delete state.queue[id]
      state.progressFiles = state.progressFiles.filter((x) => x.id != id)
      if (!state.queue) {
        state.queue = {}
      }
      const hasPendingTask = Object.values(state.queue).some(
        (item) => item && item.task_id && !item.isDone
      )
      if (!hasPendingTask) {
        unregisterTaskSource(POLL_SOURCE_KEY)
      }
    },
    setConfigSend(state, { id, config }) {
      state.configSend[id] = config
    },
  },
  actions: {
    // _UPLOAD_FILE
    async callUpload(
      { commit, dispatch },
      { url, data, option, name = 'Tải lên', cbWhenComplete }
    ) {
      commit('showDialog')
      const id = new Date().getTime()
      const CancelToken = axios.CancelToken
      const source = CancelToken.source()
      const file_temp = {
        id,
        name,
        isDone: false,
        isError: false,
        isProcessing: false,
        task_id: null,
        statusMessage: '',
        cancel: () => source.cancel(),
      }

      const config = {
        method: 'post',
        url,
        data,
        headers: { 'Content-Type': 'multipart/form-data' },
        cancelToken: source.token,
        cbWhenComplete,
        ...option,
      }
      commit('setConfigSend', { id, config })
      commit('setQueueUpload', file_temp)
      dispatch('upload', { id })
      return { id, queue: file_temp }
    },
    // _CANCEL_UPLOAD
    async cancelUpload({ state, commit }, { id }) {
      const file = state.queue[id]
      if (!file) return
      if (file.task_id && !file.isDone) {
        commit('removeQueueUpload', id)
        return
      }
      if (!file.isDone && file.cancel) {
        file.cancel()
      }
    },
    // _REUPLOAD
    async reUpload({ dispatch, commit, state }, { id }) {
      const oldConfig = state.configSend[id]
      const oldFile_temp = state.progressFiles.find((x) => x.id == id)
      const CancelToken = axios.CancelToken
      const source = CancelToken.source()
      const config = {
        ...oldConfig,
        cancelToken: source.token,
      }
      const file_temp = {
        ...oldFile_temp,
        isDone: false,
        isError: false,
        isProcessing: false,
        task_id: null,
        statusMessage: '',
        error_message: '',
        cancel: () => source.cancel(),
      }
      commit('setConfigSend', { id, config })
      commit('setQueueUpload', file_temp)
      commit('updateQueue', { id, queue: file_temp })
      dispatch('upload', { id })
    },
    // _UPLOAD
    async upload({ dispatch, state, commit }, { id }) {
      const config = state.configSend[id]
      const current = () => state.queue[id] || {}

      try {
        const res = await sdk.request(config)
        const taskId = extractTaskId(res)
        if (taskId) {
          commit('updateQueue', {
            id,
            queue: {
              ...current(),
              task_id: taskId,
              isProcessing: true,
              isDone: false,
              isError: false,
              statusMessage: 'Đang xử lý...',
            },
          })
          bindTaskPoller(state, commit)
        } else {
          commit('updateQueue', {
            id,
            queue: {
              ...current(),
              task_id: null,
              isProcessing: false,
              isDone: true,
              statusMessage: '',
            },
          })
        }
        if (config.cbWhenComplete) {
          config.cbWhenComplete(res)
        }
        return res
      } catch (error) {
        const file_temp = current()
        file_temp.isError = true
        file_temp.isDone = true
        file_temp.isProcessing = false
        file_temp.task_id = null
        if (!axios.isCancel(error) || error.code != 'ECONNABORTED') {
          if (error.response) {
            if (error.response.status != 500) {
              dispatch(
                'notify/error',
                {
                  message: 'Tải lên lỗi',
                },
                {
                  root: true,
                }
              )
            }
            file_temp.error_message =
              error.response.data.message || i18n.t('error.500')
          }
          file_temp.error = error
        } else {
          file_temp.error_message = 'Hủy tải'
        }
        commit('updateQueue', { id, queue: { ...file_temp } })
      }
    },
  },
}
